// extracted by mini-css-extract-plugin
export var hero = "forbidden-403-module--hero--1f173";
export var wrapper = "forbidden-403-module--wrapper--15bfa";